import axiosClient from "./axiosClient";

export function generateInvoice(data) {
  return axiosClient.post(
    "/report_new/inv",
    data,
    { responseType: "blob" }
  );
}


export function generateSummary(data) {
  return axiosClient.post(
    "/invoice_new/summary",
    data,
    { responseType: "blob" }
  );
}

export function getInvoices() {
  return axiosClient
    .get("/admin/invoice_new")
    .then((res) => res.data);
}